import { useEffect, useRef, useState } from "react"
import { isMobile } from "react-device-detect"
import { IoIosCheckmarkCircleOutline } from "react-icons/io"
import { MdContentCopy } from "react-icons/md"
import { toast, ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import Container from "../components/base/container"
import Layout from "../components/base/layout"
import PageLayout from "../components/base/page-layout"
import Heading from "../components/common/heading"
import Modal from "../components/common/react-modal"
import MessagePopup from "../components/common/success-popup"
import ContctForm from "../components/contactus/contact-form"
import { recordPageView } from "../utils/utility"

const Contact = () => {
  const [success, setStatus] = useState(false)

  useEffect(() => {
    recordPageView("/contactus.html")
  }, [])

  return (
    <>
      <style jsx>{`
        .text-highlight {
          color: #2a65d3;
        }

        a:hover {
          text-decoration: underline;
        }
      `}</style>
      <PageLayout pageTitle="Contact Us" headTitle="Contact Lamudi" className="staticPageBanner">
        <Modal showModal={success} onClickClose={() => setStatus(false)}>
          <MessagePopup
            heading="Success"
            description={"Your message has been sent successfully."}
            icon={<IoIosCheckmarkCircleOutline />}
          />
        </Modal>
        <Container className="u-mb24">
          <Layout>
            <div>
              <p className="u-mb24">
                We aim to serve you the best way we can, and have an expert team at hand to cater to your queries at all
                times! This team is available to guide you thoroughly, no matter what your enquiry is. You can contact
                us for support in any way you want, whether it's by phone, fax, or email.
              </p>

              <div className="u-mb24">
                <Heading variant="h3">Telephone</Heading>
                <div className="text-highlight u-mb16">
                  0800-786786{" "}
                  {isMobile ? (
                    <a href="tel:+1-800-555-1234">call</a>
                  ) : (
                    <button
                      onClick={() => {
                        document.execCommand("0800-786786")
                        toast("Number copied to clipboard")
                      }}
                    >
                      <MdContentCopy />
                    </button>
                  )}
                  <span className="text-muted">(9 AM to 2 AM)</span>
                </div>
                <p>
                  We recommend emailing us using the email form on this page. Provide your contact details and your
                  email address for a quick response.
                </p>
              </div>

              <div className="u-mb24">
                <Heading variant="h3">Email</Heading>
                <a className="text-highlight" href="mailto:support@lamudi.pk">
                  support@lamudi.pk
                </a>
              </div>

              <div>
                <Heading variant="h3">Address</Heading>
                <p className="u-mb8">You can also visit us or write to us on the following address:</p>
                <div className="vcard">
                  <div className="adr u-spbwy8">
                    <p className="street-address">
                      8th Floor, Mega Tower,
                      <br />
                      63-B, <span className="street-address">Main Boulevard Gulberg</span>,<br />
                      <span className="locality">Gulberg II, </span>
                      <span className="city">Lahore</span>,<br />
                      <span className="country">Pakistan</span>.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="panel">
                <Heading className="u-mb16" variant="h4">
                  Write to us
                </Heading>
                <ContctForm setStatus={setStatus} />
                <ToastContainer />
              </div>
            </div>
          </Layout>
        </Container>
      </PageLayout>
    </>
  )
}

export default Contact
